import React, { useState, Fragment } from 'react';
import Traductor from '../../../Traductor';
import {
    Busqueda,
    dateStart,
    dateEnd,
    status,
    Solicitante,
    channelCode,
} from '../../../../constants/Filters';

import Tag from '../../../bronson/Tag';

function TagFilters({
    pSelectedFilters,
    resetFilters,
    refreshSelectedFilters,
    setField,
    countFilters,
    setFilters,
    setTagSelectedFilters,
}) {
    const t = new Traductor();
    const [showAllTags, setShowAllTags] = useState(false);
    const filtersCodes = [
        {
            code: Busqueda,
            name: t.getTraduction('TicketSearcher'),
            type: 'Input',
        },
        {
            code: dateStart,
            name:
                t.getTraduction('TicketCreationDate') +
                ' ' +
                t.getTraduction('Desde'),
            type: 'Input',
        },
        {
            code: dateEnd,
            name:
                t.getTraduction('TicketCreationDate') +
                ' ' +
                t.getTraduction('Hasta'),
            type: 'Input',
        },
        {
            code: status,
            name: t.getTraduction('Status'),
            type: 'Select',
        },
        {
            code: Solicitante,
            name: t.getTraduction('Solicitante'),
            type: 'Input',
        },
        {
            code: channelCode,
            name: t.getTraduction('Concesionario'),
            type: 'Select',
        },
    ];

    const setNewIntegerFilter = (value, code, tagsShowing, maxNumberTags) => {
        let newfilters = { ...pSelectedFilters, [code]: value };
        setField(code, '');
        setFilters(newfilters);
        setTagSelectedFilters({ ...pSelectedFilters, [code]: value });
        refreshSelectedFilters(tagsShowing);
        checkTagsInViewSeeMinus(tagsShowing, maxNumberTags);
    };

    const checkTagsInViewSeeMinus = (tagsShowing, maxNumberTags) => {
        if (tagsShowing - 1 <= maxNumberTags) {
            setShowAllTags(false);
        }
    };

    const printlistTags = () => {
        let maxNumberTags = 0;
        let extraNumberTags = 0;
        let tagsShowing = 0;
        let permisionToShow = false;
        let windowWidth = document.getElementById('TagFiltersList')
            ? document.getElementById('TagFiltersList').offsetWidth
            : 0;
        let listTags = [];

        if (windowWidth > 650) {
            maxNumberTags = 3;
        } else {
            maxNumberTags = 2;
        }

        filtersCodes &&
            filtersCodes.map((element, index) => {
                permisionToShow = tagsShowing < maxNumberTags || showAllTags;

                if (pSelectedFilters[element.code]) {
                    switch (element.type) {
                        case 'Datepicker':
                        case 'Input':
                            if (
                                pSelectedFilters[element.code] != '' &&
                                pSelectedFilters[element.code] != null
                            ) {
                                if (permisionToShow) {
                                    let text =
                                        element.name +
                                        ': ' +
                                        pSelectedFilters[element.code];
                                    listTags.push(
                                        <li key={index}>
                                            <span
                                                className="c-tag"
                                                key={
                                                    'tagFilter_' +
                                                    element.code +
                                                    '_' +
                                                    index
                                                }
                                            >
                                                <span className="c-tag__label">
                                                    {text}
                                                </span>
                                                <button
                                                    className="c-tag__close"
                                                    title="Close"
                                                    type="button"
                                                    onClick={e =>
                                                        setNewIntegerFilter(
                                                            '',
                                                            element.code,
                                                            tagsShowing,
                                                            maxNumberTags
                                                        )
                                                    }
                                                ></button>
                                            </span>
                                        </li>
                                    );
                                    tagsShowing++;
                                } else {
                                    extraNumberTags++;
                                }
                            }
                            break;
                        case 'Select':
                            if (pSelectedFilters[element.code] != '') {
                                if (permisionToShow) {
                                    let text =
                                        element.name +
                                        ': ' +
                                        pSelectedFilters[element.code];

                                    listTags.push(
                                        <li key={index}>
                                            <span
                                                className="c-tag"
                                                key={
                                                    'tagFilter_' +
                                                    element.code +
                                                    '_' +
                                                    index
                                                }
                                            >
                                                <span className="c-tag__label">
                                                    {text}
                                                </span>
                                                <button
                                                    className="c-tag__close"
                                                    title="Close"
                                                    type="button"
                                                    onClick={e =>
                                                        setNewIntegerFilter(
                                                            '',
                                                            element.code,
                                                            tagsShowing,
                                                            maxNumberTags
                                                        )
                                                    }
                                                ></button>
                                            </span>
                                        </li>
                                    );
                                    tagsShowing++;
                                } else {
                                    extraNumberTags++;
                                }
                            }
                            break;
                        default:
                            break;
                    }
                }
            });
        countFilters(tagsShowing);
        if (tagsShowing > 0 && extraNumberTags > 0 && !showAllTags) {
            listTags.push(
                <li>
                    <Tag
                        classes={['flat']}
                        text={t.getTraduction('ViewAll')}
                        type="button"
                        clickFunction={e => setShowAllTags(true)}
                    ></Tag>
                </li>
            );
        } else {
            if (showAllTags && tagsShowing > 0) {
                listTags.push(
                    <li>
                        <Tag
                            classes={['flat']}
                            text={t.getTraduction('ViewLess')}
                            type="button"
                            clickFunction={e => setShowAllTags(false)}
                        ></Tag>
                    </li>
                );
            }
        }

        if (tagsShowing > 0 && tagsShowing >= 2 && windowWidth > 0) {
            listTags.push(
                <li key={t.getTraduction('ResetFilters')}>
                    <Tag
                        classes
                        text={t.getTraduction('ResetFilters')}
                        type="button"
                        clickFunction={e => resetFilters(setField)}
                    ></Tag>
                </li>
            );
        }

        return listTags;
    };

    return <Fragment>{printlistTags()}</Fragment>;
}

export default TagFilters;
